var _rect, _ellipse, _path, _path2, _ellipse2, _path3, _path4, _path5, _path6, _path7, _ellipse3, _ellipse4, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCigarette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: 28,
    height: 298,
    viewBox: "0 0 28 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-characteristic": "cigarette",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 297.5,
    transform: "matrix(-1 0 0 1 28 4.75)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 302.689,
    rx: 14,
    ry: 4.8267,
    fill: "#E3E4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4.75L0 4.75L0 209.196L14.4828 212.33L28 209.196L28 4.75Z",
    fill: "#E3E4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 209.227L14 212.332L-7.62939e-06 209.227L-7.62939e-06 302.25H28L28 209.227Z",
    fill: "#E3E4F4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 302.688,
    rx: 14,
    ry: 4.8267,
    "data-characteristic": "filter"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 208.25L22.5 211.25L14 212.332L6.5 211.25L-7.62939e-06 208.25L-7.62939e-06 302.25H28L28 208.25Z",
    "data-characteristic": "filter"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 208.25V4.75H10V211.36L5 211.25L0 208.25Z",
    fill: "url(#paint0_linear_4950_109445)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M18 4.75H28V208.25L23 210.75L18 211.515V4.75Z",
    fill: "url(#paint1_linear_4950_109445)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10 307.315V211.445L5 210.75L1.52588e-05 208.25L0 302.25H0.0568428C0.0196571 302.393 0.000452042 302.537 1.52588e-05 302.683V302.693C0.00655842 304.877 4.22152 306.722 10 307.315Z",
    fill: "url(#paint2_linear_4950_109445)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M18 307.315C23.783 306.721 28 304.875 28 302.688C28 302.54 27.9808 302.394 27.9432 302.25H28V208.25L23 210.75L18 211.445V307.315Z",
    fill: "url(#paint3_linear_4950_109445)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 5.189,
    rx: 14,
    ry: 4.8267,
    fill: "#F1F2F9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9999,
    cy: 4.75007,
    rx: 11.1034,
    ry: 3.51032,
    fill: "#AAADE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7199 207.471C26.4228 209.474 20.7731 210.982 14 210.982C7.22693 210.982 1.57723 209.474 0.28006 207.471C0.0964088 207.755 0 208.048 0 208.349C0 210.772 6.26801 212.737 14 212.737C21.732 212.737 28 210.772 28 208.349C28 208.048 27.9036 207.755 27.7199 207.471Z",
    fill: "#FF7347"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0019 8.96286C20.1342 8.96286 25.1053 7.07691 25.1053 4.75048C25.1053 4.00084 24.5892 3.29694 23.6843 2.68713C23.5153 2.76993 23.3658 2.85085 23.3413 2.86831C23.2049 2.96567 23.0408 2.97815 22.8734 2.99088C22.7426 3.00082 22.6098 3.01092 22.4866 3.06181C22.3311 3.12606 22.2983 3.06494 22.2537 2.98173C22.2335 2.9442 22.211 2.90217 22.1737 2.86513C22.1381 2.82978 22.1067 2.79528 22.0764 2.76198C22.0002 2.67826 21.9309 2.60207 21.8186 2.5387C21.8077 2.53258 21.7954 2.52597 21.7822 2.51885C21.6856 2.46679 21.539 2.38778 21.5358 2.27876C21.5348 2.24709 21.5462 2.2009 21.5586 2.15009C21.5931 2.0095 21.6362 1.83359 21.4522 1.83208C21.2814 1.83069 21.2563 1.77521 21.2278 1.71233C21.2057 1.66363 21.1816 1.61048 21.0863 1.57458C20.9709 1.53113 20.8475 1.56328 20.7257 1.59498C20.6522 1.61413 20.5793 1.63312 20.5091 1.63518C20.4272 1.63759 20.1481 1.75017 19.9505 1.82988C19.8334 1.87712 19.7449 1.91281 19.7431 1.90717C19.6735 1.69337 19.4463 1.77641 19.2454 1.84986C19.2294 1.85569 19.2137 1.86146 19.1981 1.86701C19.1623 1.87984 19.1615 1.84918 19.1606 1.81403C19.1597 1.78047 19.1587 1.74282 19.127 1.73498C19.0252 1.70981 18.9274 1.76866 18.8481 1.82114C18.784 1.86359 18.7871 1.82192 18.7911 1.76647C18.7938 1.73072 18.7968 1.68924 18.7826 1.66088C18.7334 1.56298 18.6553 1.56953 18.5596 1.57757C18.537 1.57946 18.5135 1.58144 18.4892 1.58215C18.4512 1.58327 18.3981 1.58844 18.3366 1.59444C18.0888 1.61861 17.7036 1.65618 17.6102 1.49565C17.5668 1.42111 17.5673 1.36279 17.5677 1.31947C17.5684 1.2466 17.5686 1.21616 17.359 1.22231C17.1601 1.22815 17.1503 1.13974 17.1364 1.01489C17.1308 0.964368 17.1245 0.90788 17.1048 0.849252C17.0132 0.576969 16.5715 0.9392 16.4344 1.05165L16.4327 1.05299C16.4229 1.06101 16.4064 1.07941 16.3864 1.1016C16.3277 1.16681 16.2396 1.26474 16.2076 1.22802C16.1617 1.17535 16.0504 1.20029 16.0032 1.24025C15.9854 1.25533 15.9684 1.27008 15.952 1.28429C15.7815 1.43189 15.6792 1.52049 15.4903 1.30832C15.4647 1.27961 15.4413 1.24765 15.4186 1.21662C15.3281 1.09278 15.2483 0.983663 15.0827 1.15497C15.0273 1.21228 15.0019 1.29868 14.9772 1.38276C14.9338 1.53056 14.8925 1.6712 14.6938 1.63422C14.6129 1.61915 14.574 1.54959 14.5378 1.48483C14.5304 1.47154 14.5231 1.45845 14.5155 1.44607C14.4724 1.37525 14.4 1.39228 14.3245 1.41005C14.2919 1.41772 14.2587 1.42554 14.2271 1.42647C14.0246 1.43241 13.8978 1.39951 13.7403 1.35859C13.71 1.35074 13.6787 1.34259 13.6454 1.33436C13.5907 1.32084 13.5436 1.37156 13.4903 1.42893C13.4259 1.49823 13.3526 1.57722 13.246 1.56441C13.1907 1.55777 13.1301 1.52645 13.0725 1.49662C12.9495 1.43296 12.8395 1.37604 12.821 1.57999C12.8042 1.76464 12.4585 1.46506 12.4133 1.42353C12.388 1.4003 12.3638 1.37196 12.3398 1.34392C12.259 1.24943 12.181 1.15833 12.0763 1.27746C12.0365 1.32277 12.0123 1.38616 11.9883 1.44864C11.9468 1.55717 11.9063 1.66297 11.7872 1.66646C11.6393 1.6708 11.4867 1.63495 11.3556 1.56684C11.3421 1.55985 11.3256 1.54142 11.3083 1.52208C11.283 1.49386 11.256 1.46371 11.2342 1.46435C11.212 1.46501 11.1935 1.47632 11.1738 1.48845C11.145 1.50613 11.1134 1.52554 11.063 1.51616C11.0072 1.50577 10.996 1.46348 10.9858 1.42493C10.9776 1.39375 10.97 1.36501 10.94 1.35758C10.8656 1.33919 10.7823 1.36846 10.7064 1.39512C10.6804 1.40429 10.6552 1.41314 10.6315 1.41965C10.3961 1.48443 10.2522 1.48299 10.0244 1.44058C9.85216 1.40852 9.66818 1.55202 9.51595 1.67075C9.46873 1.70759 9.42456 1.74204 9.38474 1.76812C9.3095 1.81742 9.24726 1.80016 9.18604 1.75524C9.1248 1.7103 9.05651 1.77397 9.00372 1.82317C8.98698 1.83878 8.97179 1.85294 8.95889 1.86171C8.75026 2.00352 8.43383 2.19702 8.18609 2.12142C8.12669 2.1033 8.07845 2.07052 8.03398 2.04029C7.93491 1.97297 7.85453 1.91835 7.71106 2.06674C7.69604 2.08228 7.68261 2.09645 7.67037 2.10939C7.56492 2.22076 7.54672 2.23998 7.34212 2.24599C7.29864 2.24726 7.25763 2.23995 7.22038 2.2333C7.12755 2.21674 7.058 2.20433 7.03141 2.33931C7.00517 2.47252 6.74538 2.32198 6.58996 2.23192C6.55716 2.21292 6.52901 2.1966 6.50869 2.18622C6.45931 2.161 6.40569 2.11359 6.35239 2.06646C6.2395 1.96665 6.12804 1.8681 6.06128 1.98414C5.93718 2.19983 5.83182 2.4186 5.72617 2.63799C5.6726 2.74924 5.61895 2.86064 5.56274 2.97188C5.44256 3.20973 5.06478 3.27029 4.85054 3.11753C4.79245 3.07611 4.76207 3.16033 4.72818 3.25431C4.69438 3.34803 4.65708 3.45147 4.58529 3.44969C4.5096 3.44781 4.44208 3.42414 4.37308 3.39995C4.27257 3.36471 4.16892 3.32838 4.03236 3.35674C3.92721 3.37858 3.84937 3.4493 3.77614 3.51585C3.71331 3.57294 3.65386 3.62695 3.58346 3.64438C3.48905 3.66776 3.41908 3.61391 3.36435 3.53918C3.06127 3.9228 2.89844 4.32943 2.89844 4.75048C2.89844 7.07691 7.86962 8.96286 14.0019 8.96286Z",
    "data-characteristic": "bag"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4950_109445",
    x1: 1.05548e-7,
    y1: 102.298,
    x2: 10,
    y2: 102.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4950_109445",
    x1: 28,
    y1: 108.903,
    x2: 18,
    y2: 108.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4950_109445",
    x1: 3.42963e-7,
    y1: 258.444,
    x2: 10,
    y2: 258.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4950_109445",
    x1: 28,
    y1: 262.571,
    x2: 18,
    y2: 262.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCigarette);
export default __webpack_public_path__ + "static/media/cigarette.1994a77a072bb3e97819086f7e57e945.svg";
export { ForwardRef as ReactComponent };